/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { MeshBasicMaterial, sRGBEncoding } from 'three'
import { useLoader } from '@react-three/fiber'
import * as THREE from 'three';
import { Vector2 } from 'three';

export default function Dome({ ...props }) {
  const group = useRef()

  const sky = useLoader(
    THREE.TextureLoader,
    './DomeSchool.jpg'
  )

  sky.flipY = false;
  sky.encoding = sRGBEncoding;
  //sky.offset = new Vector2(0, 0.085)
  sky.offset = new Vector2(0.05, -0.29)


  const mat = new MeshBasicMaterial({
    map: sky
  })



  const { nodes, materials } = useGLTF('/ModelsGLB/Room/Dome.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.Sphere001.geometry}
        material={mat}
        position={[-1.57, 0, -1.98]}
        scale={0.01}
      />
    </group>
  )
}

useGLTF.preload('/Dome.glb')
